import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class OffcanvasService {
  private instances: { [id: string]: any } = {};

  async register(id: string, element: HTMLElement) {
    if (typeof window === 'undefined') return;
    const bootstrap = await import('bootstrap');
    const Offcanvas = bootstrap.Offcanvas;
    this.instances[id] = Offcanvas.getOrCreateInstance(element);
  }

  async open(id: string): Promise<void> {
    if (typeof document === 'undefined') return;
    let instance = this.instances[id];
    if (!instance) {
      const el = document.getElementById(id);
      if (!el) {
        console.error(`Offcanvas with ID '${id}' not found in DOM`);
        return;
      }
      await this.register(id, el);
      instance = this.instances[id];
    }
    instance?.show();
  }

  close(id: string): void {
    if (typeof window === 'undefined') return;
    const instance = this.instances[id];
    instance?.hide();
  }
}